export const ApiErrorCodes = {
  USER_FACING_EXCEPTION: 10001,
};
